// Account Point Of Sales
export enum PointOfSales {
    ADD_LISTING_POS_SUCCESS = "addlisting_success",
    EDIT_LISTING_POS_SUCCESS = "editlisting_success",
    ADD_LISTING_POS_PENDING = "addlisting_pendingpayment",
    EDIT_LISTING_POS_PENDING = "editlisting_pendingpayment",
    MYLISTINGVIEW_PENDINGPAYMENT_ACTIVATELISTING = 'mylistingview_pendingpayment_activatelisting',
    MYLISTINGVIEW_DELETED_LISTING_ACTIVATELISTING = 'mylistingview_deleted_listing_activatelisting'

}